//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import { format } from "date-fns";
	import { mapGetters } from "vuex";

	export default {
		name: "AppResult",
		props: {
			result: Object,
			index: Number,
			results: Array,
		},
		components: {},
		data() {
			return {};
		},
		computed: {
			...mapGetters([
				"siteName"
			]),
			displayDate() {
				return format(new Date(this.result.itemDate), "MMM d, yyyy");
			},
			displaySize() {
				if (!!this.result.meta.resource_size && this.result.meta.resource_size.split(" ").length > 0) {
					return this.result.meta.resource_size.split(" ").join("");
				} else return this.result.meta.resource_size;
			},
			displayType() {
				let type = this.result.meta.resource_type;
				type = type.split("/")[type.split("/").length - 1];
				let alphaRegex = /^[a-zA-Z0-9]+$/g;
				if (!type.match(alphaRegex)) {
					let pathArray = this.result.url.split("/").filter(p => !!p);
					let file = pathArray[pathArray.length - 1];
					let fileType = file.split(".")[file.split(".").length - 1];
					return fileType;
				}
				return type;
			},
		},
	};
